"use strict";
/**
 * Created by wangtong on 2020/12/30
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrimaryValue = exports.deepCopy = exports.isEmpty = void 0;
/**
 * 判断空值
 */
function isEmpty(data) {
    if (typeof data === 'string') {
        data = data.replace(new RegExp('(^\\s*)|(\\s*$)', 'g'), '');
        return data === '' || data == null || data === 'null' || data === 'undefined';
    }
    else if (typeof data === 'undefined') { // 未定义
        return true;
    }
    else if (typeof data === 'number') {
        return false;
    }
    else if (typeof data === 'boolean') {
        return false;
    }
    else if (Array.isArray(data)) {
        // 数组
        if (data.length === 0) {
            return true;
        }
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var value = data_1[_i];
            if (!isEmpty(value)) {
                return false;
            }
        }
        return true;
    }
    else {
        if (JSON.stringify(data) === '{}') {
            return true;
        }
        else
            return data == null;
    }
}
exports.isEmpty = isEmpty;
/**
 * 深拷贝
 * @param value
 * @returns {any}
 */
function deepCopy(value) {
    return JSON.parse(JSON.stringify(value));
}
exports.deepCopy = deepCopy;
var json_1 = require("./json");
Object.defineProperty(exports, "getPrimaryValue", { enumerable: true, get: function () { return json_1.getPrimaryValue; } });
//# sourceMappingURL=index.js.map